export enum RateOptionEnum {
  SATISFIED = 1,
  UNSATISFIED = 2,
  NO_CONTACT = 3,
}

export enum RateReasonEnum {
  NO_ANSWER = 4,
  NOT_PROFESSIONAL = 5,
  NOT_AVAILABLE = 7,
  WRONG_DETAILS = 10,
  OTHERS = 11,
}
